import { Building, Route, Plane, Globe2, MapPin } from "lucide-react";
import { Reveal, Chapter } from "./Reveal";

const AUDIENCES = [
  { icon: Building, title: "DMCs", copy: "Digitize destination supply and streamline enquiries, quotations and sales.", featured: true, tid: "who-dmcs" },
  { icon: Route, title: "Tour Operators", copy: "Build packages, manage pricing and create a scalable digital storefront.", tid: "who-operators" },
  { icon: Plane, title: "Incoming Operators", copy: "Centralize destination products and simplify B2B and B2C sales.", tid: "who-incoming" },
  { icon: Globe2, title: "Travel Companies", copy: "Create branded destination experiences without building technology from scratch.", tid: "who-companies" },
  { icon: MapPin, title: "Local Destination Experts", copy: "Turn destination knowledge and supplier relationships into a digital business.", tid: "who-experts" },
];

export default function WhoFor() {
  return (
    <section id="who" className="py-24 lg:py-28">
      <div className="container-x">
        <Reveal><Chapter index={11} label="Who It's For" /></Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-8 max-w-2xl font-serif text-3xl leading-[1.15] tracking-tight text-ink sm:text-4xl">
            Built for the businesses that know their destination best.
          </h2>
        </Reveal>
        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-5">
          {AUDIENCES.map((a, i) => (
            <Reveal key={a.title} delay={0.06 * i}>
              <div
                id={a.tid}
                data-testid={a.tid}
                className={`flex h-full flex-col rounded-2xl border p-6 transition-all duration-500 hover:-translate-y-1.5 ${
                  a.featured ? "border-ink bg-ink text-paper" : "border-sand bg-white hover:border-terra/50"
                }`}
              >
                <a.icon className="h-5 w-5 text-terra" />
                <h3 className={`mt-4 text-base font-bold leading-snug ${a.featured ? "text-paper" : "text-ink"}`}>{a.title}</h3>
                <p className={`mt-2 flex-1 text-xs leading-relaxed ${a.featured ? "text-paper/70" : "text-stone2"}`}>{a.copy}</p>
                {a.featured && (
                  <span className="mt-4 w-max rounded-full bg-terra px-2.5 py-1 font-mono text-[9px] font-bold uppercase tracking-widest text-ink">
                    Primary customer
                  </span>
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
